/**
 * AUTO-GENERATED — DO NOT EDIT
 *
 * Generated by tools/gen-sqlite-from-db-schema.ts
 * To regenerate, run: pnpm powersync:schema:generate
 */

import { integer, real, sqliteTable, text } from 'drizzle-orm/sqlite-core';

export const patientPackages = sqliteTable('patient_packages', {
  id: text('id').primaryKey().notNull(),
  org_id: text('org_id'),
  patient_id: text('patient_id'),
  clinic_id: text('clinic_id'),
  source_invoice_id: text('source_invoice_id'),
  source_invoice_item_id: text('source_invoice_item_id'),
  package_inventory_item_id: text('package_inventory_item_id'),
  package_name_snapshot: text('package_name_snapshot'),
  package_code_snapshot: text('package_code_snapshot'),
  package_price_snapshot: real('package_price_snapshot'),
  purchase_date: text('purchase_date'),
  valid_until: text('valid_until'),
  validity_months_snapshot: integer('validity_months_snapshot'),
  payment_status: text('payment_status'),
  redemption_status: text('redemption_status'),
  activated_at: text('activated_at'),
  activated_by: text('activated_by'),
  activation_reason: text('activation_reason'),
  suspended_at: text('suspended_at'),
  suspended_by: text('suspended_by'),
  suspension_reason: text('suspension_reason'),
  voided_at: text('voided_at'),
  voided_by: text('voided_by'),
  void_reason: text('void_reason'),
  created_at: text('created_at'),
  updated_at: text('updated_at'),
  deleted_at: text('deleted_at'),
});
